import Vue from 'vue';
import VueRouter from 'vue-router';
import BasicLayout from '@/layouts/BasicLayout';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};


const routes = [
  {
    path: '/', // 首页
    name: 'index',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/index'),
  },
  {
    path: '/bidSecurity', // 投标保函
    name: 'bidSecurity',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/bidSecurity'),
  },
  {
    path: '/bidStep',
    name: 'bidStep',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/bidStep'),
  },
  {
    path: '/performStep', // 履约保函
    name: 'performStep',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/performStep'),
  },
  {
    path: '/performance',
    name: 'performance',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/performance'),
  },
  {
    path: '/advanceCharge', // 预付款保函
    name: 'advanceCharge',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/advanceCharge'),
  },
  {
    path: '/quality', // 质量保函
    name: 'quality',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/quality'),
  },
  {
    path: '/migrantWorkers', // 农民工工资保函
    name: 'migrantWorkers',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/guaranteeServe/migrantWorkers'),
  },
  {
    path: '/orderDetail', // 查看订单
    name: 'orderDetail',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/orderCenter/orderDetail'),
  },
  {
    path: '/payIndex', // 支付页面
    name: 'payIndex',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/orderCenter/payIndex'),
  },
  {
    path: '/applyinformation', // 申请信息
    name: 'applyinformation',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/orderCenter/applyInformation'),
  },
  {
    path: '/guaranteeTruth', // 保函验真
    name: 'guaranteeTruth',
    meta: {
      isHide: 2,
    },
    component: () => import('../views/guaranteeTruth'),
  },
  {
    path: '/letterTruth', // 保函验真2
    name: 'letterTruth',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/letterTruth'),
  },
  {
    path: '/demo', // 保函验真
    name: 'demo',
    meta: {
      isHide: 2,
    },
    component: () => import('../views/demo'),
  },
  {
    path: '/brandintroduction', // 关于我们
    name: 'brandintroduction',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/brandintroduction'),
  },
  {
    path: '/industryTrends', // 行业动态
    name: 'industryTrends',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/industryTrends'),
  },
  {
    path: '/advantage', // 我们的优势
    name: 'advantage',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/advantage'),
  },
  {
    path: '/contact', // 联系我们
    name: 'contact',
    meta: {
      isHide: 1,
    },
    component: () => import('../views/contact'),
  },
  {
    path: '/login',
    name: 'login',
    component: BasicLayout,
    // redirect: '/login',
    children: [
      {
        path: '/login', // 登录
        name: 'login',
        meta: {
          isHide: 2,
        },
        component: () => import('../views/login'),
      },
      {
        path: '/forgotPassword', // 忘记密码
        name: 'forgotPassword',
        component: () => import('../views/forgotPassword'),
      },
      {
        path: '/register', // 注册
        name: 'register',
        component: () => import('../views/register'),
      },
      {
        path: '/entCertForm', // 企业认证表单
        name: 'entCertForm',
        component: () => import('../views/entCertification/form.vue'),
      },
      {
        path: '/entCertification', // 企业认证表单
        name: 'entCertification',
        component: () => import('../views/entCertification'),
      },
      {
        path: '/products', // 选择产品
        name: 'products',
        meta: {
          isHide: 2,
        },
        component: () => import('../views/products'),
      },
      {
        path: '/orderCenter', // 订单中心
        name: 'orderCenter',
        meta: {
          isHide: 2,
        },
        component: () => import('../views/orderCenter'),
      },
      {
        path: '/applyGuarantee', // 申请保函
        name: 'applyGuarantee',
        meta: {
          isHide: 2,
        },
        component: () => import('../views/applyGuarantee'),
      },
      {
        path: '/user', // 账户管理
        name: 'user',
        meta: {
          isHide: 2,
        },
        component: () => import('../views/user'),
      },
      {
        path: '/insure/project', // 申请保函
        name: 'Project',
        component: () => import('../views/project'),
      },
      {
        path: '/insure/project/view',
        name: 'ProView',
        component: () => import('../views/project/components/view.vue'),
      },
      {
        path: '/bankInsure',
        name: 'bankInsure',
        component: () => import('../views/project/components/bankInsure.vue'),
      },
      {
        path: '/demo/insure',
        name: 'Insure',
        component: () => import('../views/insure'),
      },
      {
        path: '/demo/insureConfirm',
        name: 'insureConfirm',
        component: () => import('../views/insureConfirm'),
      },
      {
        path: '/demo/order',
        name: 'order',
        component: () => import('../views/order'),
      },
      {
        path: '/demo/history',
        name: 'history',
        component: () => import('../views/history'),
      },
      {
        path: '/insure',
        name: 'Insure',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insure/index'),
      },
      {
        path: '/NonInsure',
        name: 'NonInsure',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/NonInsure/form.vue'),
      },
      {
        path: '/insurePre',
        name: 'InsurePre',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePre/index'),
      },
      {
        path: '/insurePreAQHuaShang',
        name: 'InsurePreAQHuaShang',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreAQHuaShang/index'),
      },
      {
        path: '/insurePreQSHuaShang',
        name: 'InsurePreQSHuaShang',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreQSHuaShang/index'),
      },
      {
        path: '/insurePreYueXi',
        name: 'InsurePreYueXi',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreYueXi/index'),
      },
      {
        path: '/insurePreZhanJiang',
        name: 'InsurePreZhanJiang',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreZhanJiang/index'),
      },
      {
        path: '/insurePreFoShan',
        name: 'InsurePreFoShan',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreFoShan/index'),
      },
      {
        path: '/insurePreZhongLiang',
        name: 'InsurePreZhongLiang',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreZhongLiang/index'),
      },
      {
        path: '/insurePreGuangZheng',
        name: 'InsurePreGuangZheng',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreGuangZheng/index'),
      },
      {
        path: '/insurePreZxjHzhc',
        name: 'InsurePreZxjHzhc',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreZxjHzhc/index'),
      },
      {
        path: '/insurePreZxjZhdb',
        name: 'InsurePreZxjZhdb',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreZxjZhdb/index'),
      },
      {
        path: '/insurePreZxjHhdb',
        name: 'InsurePreZxjHhdb',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreZxjHhdb/index'),
      },

      {
        path: '/insurePreQuota',
        name: 'InsurePreQuota',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreQuota/index'),
      },
      {
        path: '/insureQuota',
        name: 'InsureQuota',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insureQuota/index'),
      },
      {
        path: '/insurePreWj',
        name: 'InsurePreeWj',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreWj/index'),
      },
      {
        path: '/insurePreQS',
        name: 'InsurePreQS',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insurePreQS/index'),
      },
      {
        path: '/nonBidInsure',
        name: 'NonBidInsure',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/nonBidInsure/index'),
      },
      // {
      //   path: '/payment',
      //   name: 'Payment',
      //   meta: {
      //     isShow: 1,
      //     isHide: 1,
      //   },
      //   component: () => import('../views/insure/payment'),
      // },
      {
        path: '/baofupayment', //
        name: 'baofupayment',
        meta: {
          isFooter: 3,
          isHide: 1,
          isShow: 1,
        },
        component: () => import('../views/baofupayment/index'),
      },
      {
        path: '/payment', //
        name: 'payment',
        meta: {
          isFooter: 5,
          isHide: 1,
          isShow: 1,
        },
        component: () => import('../views/payment/index'),
      },
      {
        path: '/payInfo', //
        name: 'payInfo',
        meta: {
          isFooter: 5,
          isHide: 1,
          isShow: 1,
        },
        component: () => import('../views/payInfo/index'),
      },
      {
        path: '/nonBidPayInfo', //
        name: 'nonBidPayInfo',
        meta: {
          isFooter: 5,
          isHide: 1,
          isShow: 1,
        },
        component: () => import('../views/nonBidPayInfo/index'),
      },
      {
        path: '/insure/basicDoor',
        name: 'BasicDoor',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/insure/components/BasicDoor.vue'),
      },
      {
        path: '/enterForm', // 保函录入
        name: 'enterForm',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/enter/form.vue'),
      },
      {
        path: '/centerOrderList', // 交易中心保函列表
        name: 'centerOrderList',
        meta: {
          isShow: 1,
          isHide: 1,
        },
        component: () => import('../views/centerOrderList/index.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
